import { useEffect, useState } from 'react';
import api, { readProfileUser, restorePortalSession } from '../utils/api';
import { clearPortalLoginGuard } from '../utils/portalLogin';

export function useAccessCheck() {
  const [user, setUser] = useState<{ id: number; email: string; role: string } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [blocked, setBlocked] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let disposed = false;
    setLoading(true);
    setError('');
    const check = async () => {
      // Нет локального токена — пробуем сессию портала из cookie (вход на start.3a-fb.info).
      if (!localStorage.getItem('token') && !(await restorePortalSession())) { if (!disposed) setLoading(false); return; }
      try {
        const response = await api.get('/api/auth/profile');
        if (disposed) return;
        const profile = readProfileUser(response.data);
        // Профиль ответил, но пользователя не прочитать: это сбой, а не выход. Уход на /login
        // здесь дал бы цикл — страница входа видит рабочую сессию и возвращает обратно.
        if (profile) { clearPortalLoginGuard(); setUser(profile); }
        else setError('Не удалось проверить вход. Ваша сессия сохранена. Повторите проверку.');
      } catch (err: any) {
        if (disposed) return;
        const status = err?.response?.status;
        if (status === 401 || status === 403) {
          setUser(null);
          setBlocked(status === 403 && err?.response?.data?.error === 'Account suspended');
        } else {
          setError(status === 429
            ? 'Слишком много запросов. Подождите немного и повторите проверку входа.'
            : 'Не удалось проверить вход. Ваша сессия сохранена. Повторите проверку.');
        }
      } finally { if (!disposed) setLoading(false); }
    };
    check();
    return () => { disposed = true; };
  }, [attempt]);
  return { user, loading, error, blocked, retry: () => setAttempt(value => value + 1) };
}
